export const banner = {
  'camp67-banner.inquire-now': 'Express Interest',
  'camp67-banner.book-now': 'Book now',
};

export const navigation = {
  'camp67-navigation.the-camp': 'The Camp',
  'camp67-navigation.camp67': 'camp67',
  'camp67-navigation.camp67.who-are-we': 'Who are we?',
  'camp67-navigation.camp67.camp67-&-kumbh': 'camp67 & Kumbh',
  'camp67-navigation.camp67.camp67-&-the-land': 'camp67 & the Land',
  'camp67-navigation.kumbh-2025': 'Magh Mela 2026',
  'camp67-navigation.kumbh-2025.sacred-gathering-of-magh-mela':
    'Magh Mela: A Sacred Gathering',
  'camp67-navigation.kumbh-2025.paush-purnima': 'Pausha Purnima (Jan 3)',
  'camp67-navigation.kumbh-2025.makar-sankranti': 'Makar Sankranti (Jan 14)',
  'camp67-navigation.kumbh-2025.mauni-amavasya': 'Mauni Amavasya (Jan 18)',
  'camp67-navigation.kumbh-2025.basant-panchami': 'Basant Panchami (Jan 23)',
  'camp67-navigation.kumbh-2025.maghi-purnima': 'Maghi Purnima (Feb 1)',
  'camp67-navigation.kumbh-2025.maha-shivratri': 'Maha Shivratri (Feb 15)',
  'camp67-navigation.packages': 'Packages',
  'camp67-navigation.packages.reserve-a-room': 'Reserve a room',
  'camp67-navigation.packages.twin-room': 'Twin Bed Cottage',
  'camp67-navigation.packages.premium-twin-room': 'Premium Cottage',
  'camp67-navigation.packages.family-room': 'Family Cottage',
  'camp67-navigation.packages.family-room-plus': 'Family Cottage Plus',
  'camp67-navigation.packages.dormitory-single': 'Dormitory (Single)',
  'camp67-navigation.packages.private-group-cottage': 'Private Group Cottage',
  'camp67-navigation.packages.dormitory-bunk': 'Dormitory (Bunk)',
  'camp67-navigation.contact-us': 'Contact us',
};

export const camp67Header = {
  'camp67-header.tagline': 'A Sacred Gathering of Peace.',
  'camp67-header.typewriter.prefix': 'Stay at the most ',
  'camp67-header.typewriter.serene': 'serene',
  'camp67-header.typewriter.peaceful': 'peaceful',
  'camp67-header.typewriter.safe': 'safe',
  'camp67-header.typewriter.secure': 'secure',
  'camp67-header.typewriter.hygienic': 'hygienic',
  'camp67-header.typewriter.affordable': 'affordable',
  'camp67-header.typewriter.suffix.start': 'campsite of',
  'camp67-header.typewriter.suffix.end': 'Magh Mela 2026.',
  'camp67-header.reserve-your-spot.prefix.desktop': `Book now for`,
  'camp67-header.reserve-your-spot.prefix.mobile': `Book now for`,
  'camp67-header.reserve-your-spot.secure-checkout': `Secure checkout with:`,
  'camp67-header.see-prices': 'Browse offerings',
  'camp67-header.inquiry': 'Express Interest',
};

export const links = {
  'camp67-link.sukrit-wellness-tours': 'Sukrit Wellness Tours →',
  'camp67-link.kumbh-sukrit-camp': 'Kumbh Sukrit Camp →',
  'camp67-link.see-more-on': 'See more on',
  'camp67-link.learn-more': 'Learn more',
  'camp67-link.terms-of-service': 'Terms of Service',
  'camp67-link.privacy-policy': 'Privacy Policy',
  'camp67-link.payment-policy': 'Payment Policy',
  'camp67-link.cancellation-policy': 'Cancellation Policy',
};

export const common = {
  'camp67.submit': 'Submit',
  'camp67.reset': 'Reset',
  'camp67.continue': 'Payment →',
  'camp67.go-back': 'Go back',
  'camp67.ssl': 'Secured via SSL and browser security policies.',
};

export const inquiry = {
  'camp67-inquiry.event-badge': 'Magh Mela 2026 • Dec 31 - Feb 28',
  'camp67-inquiry.hero-subtitle':
    'Premium tent accommodation with modern amenities in the heart of the sacred confluence',
  'camp67-inquiry.express-interest': 'Express Interest',
  'camp67-inquiry.express-your-interest': 'Express Your Interest',
  'camp67-inquiry.modal-title': 'Express Your Interest',
  'camp67-inquiry.modal-subtitle': 'Magh Mela 2026 • Dec 31 - Feb 28',
  'camp67-inquiry.accommodation-preference': 'Accommodation Preference',
  'camp67-inquiry.no-preference': 'No preference',
  'camp67-inquiry.twin-cottage': 'Twin Bed Cottage',
  'camp67-inquiry.premium-cottage': 'Premium Cottage',
  'camp67-inquiry.family-cottage': 'Family Cottage',
  'camp67-inquiry.private-group': 'Private Group Cottage',
  'camp67-inquiry.dorm-single': 'Dorm Single Bed',
  'camp67-inquiry.dorm-bunk': 'Dorm Bunk Bed',
  'camp67-inquiry.checkin': 'Check-in',
  'camp67-inquiry.checkout': 'Check-out',
  'camp67-inquiry.checkin-date': 'Check-in Date',
  'camp67-inquiry.checkout-date': 'Check-out Date',
  'camp67-inquiry.guests': 'Guests',
  'camp67-inquiry.number-of-guests': 'Number of Guests',
  'camp67-inquiry.how-many': 'How many?',
  'camp67-inquiry.guest-singular': 'guest',
  'camp67-inquiry.guest-plural': 'guests',
  'camp67-inquiry.guests-10-plus': '10+ guests',
  'camp67-inquiry.contact-details': 'Your Contact Details',
  'camp67-inquiry.full-name': 'Full Name',
  'camp67-inquiry.email': 'Email',
  'camp67-inquiry.phone': 'Phone Number',
  'camp67-inquiry.your-name': 'Your name',
  'camp67-inquiry.email-placeholder': 'you@example.com',
  'camp67-inquiry.phone-placeholder': '+91 XXXXX XXXXX',
  'camp67-inquiry.additional-message': 'Additional Message (Optional)',
  'camp67-inquiry.message-placeholder': 'Any special requests or questions?',
  'camp67-inquiry.required-fields-error':
    'Please fill in all required fields marked with *',
  'camp67-inquiry.submit-interest': 'Submit Interest',
  'camp67-inquiry.submitting': 'Submitting...',
  'camp67-inquiry.thank-you': 'Thank You!',
  'camp67-inquiry.success-message':
    "We've received your interest and will contact you as soon as possible with availability and next steps.",
  'camp67-inquiry.close': 'Close',
  'camp67-inquiry.secure-info': '🔒 Your information is secure.',
  'camp67-inquiry.ready-to-experience': 'Ready to experience Magh Mela 2026?',
  'camp67-inquiry.interest-in': 'Express Interest in',
};

export const footer = {
  'camp67-footer.stay-informed': `<strong>Stay informed.</strong> We'll keep you posted on any discounts and sales. No spam!`,
  'camp67-footer.email.placeholder-subtle': 'Your email...',
  'camp67-footer.email.placeholder':
    'Enter your email address here. E.g., ilovecamp67@gmail.com...',
  'camp67-footer.subscribe-for-updates': 'Subscribe for updates',
  'camp67-footer.camp67-summary':
    'A part of <swt-link>Sukrit Wellness Tours</swt-link>, camp67 is from the team behind <ksc-link>Kumbh Sukrit Camp</ksc-link>. Affiliated with the Ministry of Tourism and Incredible India, we have been hosting Kumbh for 10+ years. <join-us-link >Join us</join-us-link> in 2026.',
  'camp67-footer.a-product-of': 'A product of',
  'camp67-footer.subscribe-success': `You're subscribed!`,
  'camp67-footer.subscribe-success-message': `Thank you for subscribing to our latest updates and news. We hope you're as excited as we are for what's to come!`,
  'camp67-footer.subscribe-opt-out': 'You may opt-out at any time from this subcription.',
};
